$(document).ready(function () {
	$(window).on("load", function () {
		function openModal() {
			document.body.classList.add("modal--open");
		}

		function setRegion(region) {
			localStorage.setItem("region", region);
		}

		function getRegion() {
			return localStorage.getItem("region");
		}

		function closeModal() {
			document.body.classList.remove("modal--open");
		}

		var region = getRegion();

		if (!region || region == "USA") {
			const params = new URLSearchParams(window.location.search);
			region = params.get("region");
			if (region == "UK") {
				setRegion("UK");
			}
		}

		if (!region || region == "CA") {
			const params = new URLSearchParams(window.location.search);
			region = params.get("region");
			if (region == "UK") {
				setRegion("UK");
			}
		}

		if (region !== "UK") {
			// If region isn't set, open modal
			openModal();
		}

		var modal = document.getElementById("regionModal");

		// UK button
		$(buttonUk).click(function () {
			setRegion("UK");
			closeModal();
		});

		// USA button
		$(buttonUsa).click(function () {
			setRegion("USA");
			closeModal();
		});

		// CANADA button
		$(buttonCa).click(function () {
			setRegion("CA");
			closeModal();
		});
	});
	// IE10
	if (navigator.userAgent.match(/MSIE\s([\d.]+)/)) {
		$("body").addClass("ie10");
	}

	// IE11
	if (navigator.userAgent.match(/Trident.*rv:11\./)) {
		$("body").addClass("ie11");
	}

	// IE11 & IE10 hacks because the guy that built this theme needs to be shot!
	if ($("body").hasClass("ie10") || $("body").hasClass("ie11")) {
		// Remove image loading class for IE10/IE11
		$(".product-image-gallery").removeClass("loading");

		// Cart doesn't display on hover IE11/IE10
		$("a.icon-cart-header").hover(function () {
			$(this).next("div.cart-wrapper").css("display", "block");
		});

		function remove_cart() {
			$("div.cart-wrapper").css("display", "none");
		}
		window.addEventListener("scroll", remove_cart);
	}

	// Don't allow the user to continue to the checkout if the compliance checkboxes haven't been checked...
	$("form#checkout-form").on("click", ".btn-button", function (e) {
		if ($(e.currentTarget).hasClass("checkout-btn")) {
			var check = check_compliance_checkboxes();
			if (check == false) {
				$("div.compliance-checkboxes").addClass("error");
				alert("Unfortunately we cannot process your order unless you provide your consent to the use of your personal data for fraud screening. You also need to confirm you have read and agree to our terms & conditions.");
				return false;
			} else {
				$("div.compliance-checkboxes").removeClass("error");
				return true;
			}
		}
	});

	// Check compliance checkboxes...
	function check_compliance_checkboxes() {
		var terms_conditions = $("input#terms-conditions").val();
		if (terms_conditions == "yes") {
			var check = true;
		} else {
			var check = false;
		}
		return check;
	}

	// Compliance checkboxes...
	$("div.compliance-checkboxes div.checkbox-wrapper input").on("click", function () {
		var input = $(this);
		if (input.val() == "no") {
			input.val("yes");
		} else {
			input.val("no");
		}
	});

	// Get the current product URL
	const productURL = window.location.href;

	const elementsWithVariantID = $("[variant-id]");

	// Loop through each element and attach the onclick action
	elementsWithVariantID.on("click", function () {
		const variantID = $(this).attr("variant-id");
		const newURL = updateURLParameter(productURL, "variant", variantID);
		history.pushState({path: newURL}, "", newURL);
	});

	// Function to update a URL parameter value
	function updateURLParameter(url, param, value) {
		const urlParams = new URLSearchParams(window.location.search);
		urlParams.set(param, value);
		return `${url.split("?")[0]}?${urlParams.toString()}`;
	}
});